import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from 'syf-component-library/ui/spacing';
import { formatDate } from 'syf-component-library/helpers/dateValidation';
import { CustomTextField, ErrorIcon } from './subcomponents';
import { AddAuthUserInputType } from '../../../../typings';
import getTranslation from '../../../../helpers/get-translation';
import triggerManageCardHoldersAnalytics from '../../../../helpers/trigger-manage-card-holders-analytics';
import { INPUT_MISSING_DETAILS, PAGE_NAME } from '../../../../const/analytics';
import DateOfBirthInput from '../../DateOfBirthInput';
import AddUserLegalContent from '../../AddUserLegalContent';
const MAX_LENGTH_INPUT = 25;
const AuthorizedUserForm = ({ authorizedUserInputValuesState, handleBlur, updateState, isAddAuthUserSubmitted }) => {
    const { firstNameHelpText, firstNamePlaceholder, lastNameHelpText, lastNamePlaceholder } = getTranslation();
    const isSubmittedOrTouched = (type) => {
        return (isAddAuthUserSubmitted || authorizedUserInputValuesState[type].touched);
    };
    const firstNameError = (isSubmittedOrTouched(AddAuthUserInputType.authorizedUserFirstName) &&
        authorizedUserInputValuesState.authorizedUserFirstName.errorMessage) ||
        '';
    const lastNameError = (isSubmittedOrTouched(AddAuthUserInputType.authorizedUserLastName) &&
        authorizedUserInputValuesState.authorizedUserLastName.errorMessage) ||
        '';
    const birthDateError = (isSubmittedOrTouched(AddAuthUserInputType.authorizedUserBirthDate) &&
        authorizedUserInputValuesState.authorizedUserBirthDate.errorMessage) ||
        '';
    const hasError = Boolean(firstNameError || lastNameError || birthDateError);
    if (hasError) {
        triggerManageCardHoldersAnalytics({
            errorMessage: INPUT_MISSING_DETAILS,
            pageName: PAGE_NAME.ERROR
        });
    }
    else {
        triggerManageCardHoldersAnalytics({
            pageName: PAGE_NAME.ADDITION
        });
    }
    const handleInputChange = (type, newValue) => {
        const value = typeof newValue === 'string'
            ? newValue
            : newValue.target.value;
        if (type === AddAuthUserInputType.authorizedUserBirthDate &&
            authorizedUserInputValuesState[AddAuthUserInputType.authorizedUserBirthDate].value.length <= value.length) {
            updateState({
                type,
                value: formatDate(value)
            });
        }
        else {
            updateState({
                type,
                value
            });
        }
    };
    return (_jsxs("div", { "data-testid": "add-authorized-users-form", "data-private": true, children: [_jsx(CustomTextField, { id: "first-name", autoCapitalize: "none", name: "first-name", placeholder: firstNamePlaceholder, helpText: firstNameHelpText, maxLength: MAX_LENGTH_INPUT, error: firstNameError, type: "text", value: authorizedUserInputValuesState.authorizedUserFirstName.value, errorIcon: _jsx(ErrorIcon, {}), onChange: (event) => handleInputChange(AddAuthUserInputType.authorizedUserFirstName, event), onBlur: () => handleBlur({
                    type: AddAuthUserInputType.authorizedUserFirstName
                }), width: 100 }), _jsx(Stack, { size: "large" }), _jsx(CustomTextField, { id: "last-name", autoCapitalize: "none", name: "last-name", placeholder: lastNamePlaceholder, helpText: lastNameHelpText, maxLength: MAX_LENGTH_INPUT, error: lastNameError, type: "text", value: authorizedUserInputValuesState.authorizedUserLastName.value, errorIcon: _jsx(ErrorIcon, {}), onChange: (event) => handleInputChange(AddAuthUserInputType.authorizedUserLastName, event), onBlur: () => handleBlur({
                    type: AddAuthUserInputType.authorizedUserLastName
                }), width: 100 }), _jsx(Stack, { size: "large" }), _jsx(DateOfBirthInput, { dateValue: authorizedUserInputValuesState.authorizedUserBirthDate.value, handleOnChange: (newValue) => handleInputChange(AddAuthUserInputType.authorizedUserBirthDate, newValue), handleOnBlur: () => handleBlur({
                    type: AddAuthUserInputType.authorizedUserBirthDate
                }), error: birthDateError }), _jsx(AddUserLegalContent, {})] }));
};
export default AuthorizedUserForm;
